import type { ReactNode } from 'react';

// Error con ícono + texto, nunca solo color (handoff §10).
export function ErrorMessage({ children }: { children?: ReactNode }) {
  if (!children) return null;
  return (
    <p className="gb-error" role="alert">
      <span className="gb-error__icon" aria-hidden="true">
        !
      </span>
      {children}
    </p>
  );
}
